// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1opBf","text":"styles_text__1_cp9"};